<div id="loading"><div class="indicator"><InlineSvg :src="require(`@/assets/images/logo.svg`)"></InlineSvg></div></div>